import { App, Form, Input, InputNumber, ModalFuncProps } from 'antd';
import React, { useRef } from 'react';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import { EditOutlined } from '@ant-design/icons';
import { v4 as uuidV4 } from 'uuid';
import { FlexListTemplate } from '../../../../../components';
import {
  ManagerPublicationListItemFragment,
  SetPublicationTocDepthInput,
  useSetPublicationTocDepthMutation,
} from '../../../../../services/apolloGraphqlAppApiClient/models/types';
import { usePublicationListStoreContext } from '../PublicationListStoreProvider';

export interface IUseSetPublicationTocDepthActionProps {
  publicationData: ManagerPublicationListItemFragment;
}

export interface IUseSetPublicationTocDepthActionResult {
  setPublicationTocDepthAction: ItemType;
}

export const useSetPublicationTocDepthAction = (
  props: IUseSetPublicationTocDepthActionProps,
): IUseSetPublicationTocDepthActionResult => {
  const {
    modal: { confirm },
    notification: { info },
  } = App.useApp();
  const { publicationData } = props;
  const { refetch } = usePublicationListStoreContext();

  const menuItemKey = `SetPublicationTocDepthAction-${publicationData.publicationId}`;
  const infoKey = uuidV4();
  const modalRef = useRef<ReturnType<typeof confirm>>();

  const visible = true;

  const [setPublicationTocDepthForm] = Form.useForm<SetPublicationTocDepthInput>();

  const [setPublicationTocDepthAction] = useSetPublicationTocDepthMutation({
    onCompleted: (result) => {
      // refetch();
      info({
        placement: 'topRight',
        message: `SetPublicationTocDepth status: true`,
        description: (
          <FlexListTemplate gap={5} alignItems="left" justifyContent="left" style={{ flexDirection: 'column' }}>
            {/* info */}
          </FlexListTemplate>
        ),
        key: infoKey,
        duration: 7,
      });
      refetch(
        result.setPublicationTocDepth?.publicationDto?.order
          ? result.setPublicationTocDepth.publicationDto.order - 1
          : undefined,
      );
    },
    onError: (e) => {
      return e;
    },
  });

  const handleOk: ModalFuncProps['onOk'] = () => {
    setPublicationTocDepthForm
      .validateFields()
      .then((values) => {
        return setPublicationTocDepthAction({
          variables: {
            input: { ...values },
          },
        });
      })
      .then((res) => {
        // setPublicationTocDepthForm.resetFields();
        if (modalRef.current) {
          modalRef.current.destroy();
        }
      })
      .catch((e) => {
        return e;
      });
  };

  const handleCancel = () => {
    setPublicationTocDepthForm.resetFields();
    if (modalRef.current) {
      modalRef.current.destroy();
    }
  };

  return {
    setPublicationTocDepthAction: visible
      ? {
          key: menuItemKey,
          icon: <EditOutlined />,
          label: 'Set TocDepth',
          onClick: (menuInfo) => {
            menuInfo.domEvent.preventDefault();
            menuInfo.domEvent.stopPropagation();
            modalRef.current = confirm({
              title: `Set Toc Depth for "${publicationData.title}" Publication!`,
              onOk: handleOk,
              onCancel: handleCancel,
              okText: 'Set TocDepth',
              content: (
                <Form
                  initialValues={{
                    publicationId: publicationData.publicationId,
                    // tocDepth: publicationData.tok,
                  }}
                  layout="vertical"
                  form={setPublicationTocDepthForm}
                  name="setPublicationTocDepthForm"
                >
                  <Form.Item name="publicationId" label="Id" hidden>
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="tocDepth"
                    label="Toc Depth"
                    valuePropName="value"
                    rules={[
                      {
                        required: true,
                        message: `Please select language!`,
                      },
                    ]}
                  >
                    <InputNumber precision={0} />
                  </Form.Item>
                </Form>
              ),
            });
          },
        }
      : null,
  };
};
